interface BootstrapContext {
  hash?: string;
  isInIframe?: boolean;
}

export function shouldBootstrapApplication({
  hash = window.location.hash,
  isInIframe = window.self !== window.top
}: BootstrapContext = {}): boolean {
  if (!isInIframe) {
    return true;
  }

  const hashParameters = new URLSearchParams(hash.startsWith("#") ? hash.slice(1) : hash);
  const isMsalResponse = hashParameters.has("code") || hashParameters.has("error");

  return !isMsalResponse;
}
